const Duration = {
  parse(time) {
    const minuts = time.match('([0-9]+)m');
    const seconds = time.match('([0-9]+)s');

    let duration = 0;

    if ( minuts ) {
      duration = duration + parseInt(minuts[1]) * 60;
    }
    if ( seconds ) {
      duration = duration + parseInt(seconds[1]);
    }

    return duration;
  }
};

export default Duration;
